import { idToken } from '../firebase';
import { BACKEND } from './posts';

/**
 * Put Yourself In It (screens/PutMeIn.tsx): the imagine print, drawn again
 * with the person in it from one photo. The backend keeps the photo private
 * and redraws the same post (kindling-put-me-in.service.ts); this file only
 * asks and looks.
 */
export interface PutMeInView {
  postId: string;
  status: 'ready' | 'drawing' | 'drawn' | 'failed';
  /** the print as it was, with the plain stand-in */
  before?: string;
  /** the print with them in it */
  after?: string;
  /** photos left to try */
  left: number;
}

async function call(path: string, init: RequestInit = {}): Promise<Response> {
  const token = await idToken();
  return fetch(`${BACKEND}${path}`, { ...init, headers: { Authorization: `Bearer ${token}`, ...(init.headers || {}) } });
}

function dataUrlBlob(dataUrl: string): Blob {
  const [head, b64] = dataUrl.split(',');
  const type = /data:([^;]+)/.exec(head)?.[1] || 'image/jpeg';
  const bin = atob(b64 || '');
  const bytes = new Uint8Array(bin.length);
  for (let i = 0; i < bin.length; i++) bytes[i] = bin.charCodeAt(i);
  return new Blob([bytes], { type });
}

async function read(res: Response): Promise<PutMeInView> {
  const body = await res.json().catch(() => ({}));
  if (!res.ok) throw Object.assign(new Error(body.error || `${res.status}`), { code: body.code, status: res.status });
  return body;
}

export async function lookPutMeIn(postId: string): Promise<PutMeInView> {
  return read(await call(`/api/kindling/put-me-in/${encodeURIComponent(postId)}`));
}

/** One photo (a data URL off the device), and the drawing starts. Throws with `code` (crew_off, busy, too_many, …) when it cannot. */
export async function sendPutMeIn(postId: string, selfie: string): Promise<PutMeInView> {
  const form = new FormData();
  form.append('selfie', dataUrlBlob(selfie), 'me.jpg');
  return read(await call(`/api/kindling/put-me-in/${encodeURIComponent(postId)}`, { method: 'POST', body: form }));
}
